import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Swapstations} from '../pages/layout/list-swapstations/list-swapstations.component';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { pipe } from 'rxjs';
import { Devices } from '../pages/layout/list-scooters/list-scooters.component';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SwapstationsService {

  constructor(
    private afs: AngularFirestore,
    private http: HttpClient) { }

  getSwapstations() {
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.SwapStationCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data();
        const id = action.payload.doc.id;
        // console.log(id)
        return { id, data };
      });
    });
  }


  getSwapstationsold(){
    return this.afs.collection<Swapstations>(environment.env.EnvBaseUrl+'/'+environment.env.SwapStationInfoMap).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Swapstations;
        const id = action.payload.doc.id;
        // console.log(id)
        return { id, ...data };
      });
    });
  }

  addSwapStation(data) {
    return new Promise<void>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.SwapStationInfoMap).add(data).then(res => {
       resolve();
      }, err => reject(err));
  });
  }

  // getSwapstationStatus(imeiArr){
  //   var dict = {};
  //   for (let i = 0; i < imeiArr.length; i++) {

  //     return this.afs.doc('devices'+'/'+imeiArr[i]+'/'+'SwapStn'+'/'+'Status').snapshotChanges().map(actions => {
  //       console.log(actions[0].payload.doc.data())

  //         const id = actions[0].payload.doc.id;
  //         if(imeiArr.includes(id)){
  //         const data = actions[0].payload.doc.data();
  //         console.log(id)
  //         console.log(data)
  //         dict[id]=data['online']
  //         return dict;

  //       };
  //     });

  //   }
  // }

  getEvList() {
    return this.afs.collection(environment.env.EnvBaseUrl+'/EvList').snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Swapstations;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  getAllDoorsData(IMEI) {
    return this.afs.collection<Devices>('devices'+'/'+IMEI+'/'+'Batteries').snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data();
        const id = action.payload.doc.id;
        if(['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16'].includes(id)){
          try{
            if(action.payload.doc.data()['bms_param'].battery_id!=null){
              let str=action.payload.doc.data()['bms_param'].battery_id.toString();
                if(str.length>=4){
                  let strLastFour=str.substr(-4);
                  data['bms_param'].battery_id=strLastFour
                }
              }
          }catch{}
          return { id, ...data };
        }
      });
    });
  }

  updateSwapStnDoor(door_array, door_no,id) {
    //NOTE-NUMBER OF DOORS IN POWERHIVE AND BATTERYPOOL SWAPSTATION ARE DIFFERENT THEREFORE door_array is initialized in if else
    let updatedDoorArray=[...door_array];
    // let refreshDoorArray=[...door_array]
    updatedDoorArray[door_no] = 1;

    this.afs.doc('/devices/'+id.toString()).update({'state.door_status':[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}).then(res =>{
      this.afs.doc('/devices/'+id.toString()).update({'state.door_status':updatedDoorArray});
      this.afs.collection(environment.env.EnvBaseUrl+'/DashSwapstationModuleClicks/').add({imei: id.toString(), timestamp: new Date(),  commandType: "door", updatedDoorArray: updatedDoorArray});
    }).catch(err => {
      // console.log('something went wrong '+ err)
    });

  }

  updateChargerStatus(chargerStatusList, door_no,id) {
    let OldChargerStatus=[...chargerStatusList]
    let updatedChargerStatus=[...chargerStatusList]
    if(updatedChargerStatus[door_no] == 0){
      updatedChargerStatus[door_no] = 1;
    } else {
      updatedChargerStatus[door_no] = 0;
    }

    this.afs.doc('/devices/'+id.toString()).update({'state.charger_status':OldChargerStatus}).then(res =>{
      this.afs.doc('/devices/'+id.toString()).update({'state.charger_status':updatedChargerStatus});
      this.afs.collection(environment.env.EnvBaseUrl+'/DashSwapstationModuleClicks/').add({imei: id.toString(), timestamp: new Date(), commandType: "charger", oldChargerArray:OldChargerStatus, updatedChargerStatus: updatedChargerStatus});
    }).catch(err => {
      // console.log('something went wrong '+ err)
    });
    // this.afs.collection('devices').doc(id.toString()).update({'state.charger_status': updatedChargerStatus});
  }

  assignBattery(JSONobj){
    let httpBody = {}
    httpBody=JSONobj
   return this.http.post<any>("https://prod-api-v1.batterypool.com/api/swapStation/resetBatteryDoor",httpBody).map(res=>{
    return res;
   });
  }

  editSwapstationInfoInSwapStationList(data,id) {
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.SwapStationCollection).doc('swapStationListMap').
      set({'swapStationMap':{[id]:data}},{merge:true}).then(res => { }, err => reject(err));
    });
   }

   editSwapstationInfo(data,id) {
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.SwapStationInfoMap).doc(id).update(data).then(res => {}, err => reject(err));
  });
 }

 getParticularSwapstationInfo(docId){
  if(typeof docId !== 'undefined'){
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.SwapStationInfoMap).doc(docId).snapshotChanges().pipe(map(action => {
      const data = action.payload.data();
      const id = action.payload.id;
      return { id, ...data };
    }));
  }
}

}
